import { Bell } from 'lucide-react';
import { useNotificationsQuery } from '@features/notifications/hooks/useNotificationsQuery.js';
import NotificationList from '@components/NotificationList.js';
import AppShellPage from '@components/layout/AppShellPage.js';

export default function NotificationsPage() {
  const { data: notifications } = useNotificationsQuery();
  const count = notifications?.totalCount ?? 0;
  const subtitle = count > 0 ? `${String(count)} upcoming reminder${count === 1 ? '' : 's'}` : 'No pending reminders';

  return (
    <AppShellPage
      icon={Bell}
      title="Notifications"
      subtitle={subtitle}
      narrow
    >
      <div className="rounded-2xl border border-line bg-surface shadow-sm">
        <NotificationList />
      </div>
    </AppShellPage>
  );
}
